export default "__VITE_ASSET__C$xml98W__"